import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {PingService} from '../../services/ping.service';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.css']
})
export class StartupComponent implements OnInit {

  title = 'IBD Tool';

  constructor(private router: Router, private pingService: PingService) {
    if (localStorage.getItem('user') !== null) {
      this.router.navigateByUrl('landing');
    } else {
      const token = localStorage.getItem('firebase-token');
      localStorage.clear();
      localStorage.setItem('firebase-token', token);
    }
  }

  ngOnInit(): void {
    this.pingService.ping();
  }
}
